// DSS Documentation on ApiResult - http://tiny.sc/cgapiresult
// DSS Documentation on Validation - http://tiny.sc/cgvalidation
import { ModelError } from '@app/soco/core/model-error';

export class ApiResult<T> {
    statusCode: number;
    status: boolean;
    message: string;
    data: T;
    modelErrors: ModelError[];
}
